import FrontPageArticlesMain from "../frontPageArticles/FrontPageArticlesMain";

function StudentWelcome(): JSX.Element {

    let articlesMain = (
        <div className="block border w-full max-h-full mx-6 ">
            <FrontPageArticlesMain />
        </div>
    );

    return articlesMain;
}

export default StudentWelcome;